import React from 'react'
import {browserHistory} from "react-router";
import ListTable from '../../../../basic/ListTable'
import Table from '../../../../basic/Table'
import Loader from "../../../../basic/LoaderCircle";
import TranslateText from 'src/text/modal';

function CategoryTable({loading, install_axis}) {
  return (
    <div>
      {
        loading ? <Loader/>
          : <ListTable
            canOpen={(install_axis || []).length > 4}
          >
            <Table>
              <thead>
              <tr>
                <th><TranslateText id="catalogue_category_table__article" /></th>
                <th><TranslateText id="catalogue_category_table__part" /></th>
              </tr>
              </thead>
              <tbody>
              {
                (install_axis || []).slice().sort((a, b) => a.article < b.article ? -1 : 1).map(r => {
                  return (
                    <tr
                      style={{
                        color: 'blue',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        browserHistory.push(`/item/${r.id}`)
                      }}
                    >
                      <td style={{width: '1%'}}>{r.article}</td>
                      <td>{r.attribute_lang.display_name}</td>
                    </tr>
                  )
                })
              }
              </tbody>
            </Table>
          </ListTable>
      }
    </div>
  )
}

export default CategoryTable



// WEBPACK FOOTER //
// ./src/finwhale/common/category/table/Single.js